<template>
  <v-card>
    <v-dialog v-model="confirmDeleteDialog" width="500">
      <template></template>
      <confirm-modal
          v-if="confirmDeleteDialog"
          :confirmationText="`Are you sure you want to delete this user?`"
          @dialog-clicked="removeUser"
      />
    </v-dialog>
    <v-card-title>
      <div> <span class="text-caption">Email:</span> {{ user.email }}</div>
      <div> <span class="text-caption">Name:</span> {{ user.first_name }} {{ user.last_name }}</div>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col :cols="12" class="mb-2">
          <v-row>
            <v-chip v-for="role in user.roles" :key="role" :color="getColor(role)"
                    class="text-white float-right ml-1 mb-1"> {{ role }}
            </v-chip>
          </v-row>
        </v-col>
        <v-col :cols="6">
          <v-chip
              v-if="!user.is_active"
              style="color: red"
          >User is not active</v-chip>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <div class="pr-6">
      <v-dialog v-if="hideDetail == false" v-model="editing" width="500">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="primary" depressed small>Edit User</v-btn>
        </template>
        <user-form-modal :editing="editing" :title="'Edit User'" :user="user" @dialog-clicked="editing = false"/>
      </v-dialog>
      </div>
      <div>
      <v-btn v-if="hideDetail == false" color="error" depressed small @click="confirmDelete">Delete User</v-btn>
      </div>
    </v-card-actions>
    <v-spacer></v-spacer>

  </v-card>
</template>

<script>
import ConfirmModal from '../modals/ConfirmModal.vue'
import {mapActions} from 'vuex'
import UserFormModal from '../forms/UserFormModal.vue'

export default {
  components: {ConfirmModal, UserFormModal},
  name: 'UserCard',
  props: {
    user: Object,
    hideDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      stateColors: {
        tagger: 'primary ',
        sysadmin: 'accent ',
        authadmin: 'accent ',
        qualitycontrol: 'secondary'
      },
      detailOpen: false,
      editing: false,
      confirmDeleteDialog: false
    }
  },
  mounted() {
    this.user.roles = this.user.roles.sort((a, b) => a.localeCompare(b))
  },
  methods: {
    ...mapActions(['deleteUser']),
    getColor(role) {
      let rol = role.toLowerCase()
      rol = rol.replace(/\s+/g, '')
      return this.stateColors[`${rol}`]
    },
    massAssignRoles() {
      console.log('mass assigning roles')
    },
    removeUser(e) {
      if (e) {
        this.deleteUser(this.$props.user.id)
      }
      this.confirmDeleteDialog = false
    },
    sendPasswordEmail() {
      console.log('sending password email')
    },
    confirmDelete() {
      this.confirmDeleteDialog = true
    }
  }
}
</script>

<style>
</style>
